(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var tabs = document.querySelectorAll('.products__tab');
    var grid = document.querySelector('[data-product-grid]');
    var cards = grid ? grid.querySelectorAll('.products__card') : [];

    if (!tabs.length || !cards.length || !grid) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var handle = tab.dataset.tab;

        tabs.forEach(function (t) { t.classList.remove('products__tab--active'); });
        tab.classList.add('products__tab--active');

        grid.classList.add('products__grid--fading');

        setTimeout(function () {
          cards.forEach(function (card) {
            if (handle === 'all') {
              card.classList.remove('products__card--hidden');
            } else {
              var cols = (card.dataset.collections || '').split(' ');
              if (cols.indexOf(handle) !== -1) {
                card.classList.remove('products__card--hidden');
              } else {
                card.classList.add('products__card--hidden');
              }
            }
          });

          grid.classList.remove('products__grid--fading');
        }, 250);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var tabs = document.querySelectorAll('.products__tab');
    var grid = document.querySelector('[data-product-grid]');
    var cards = grid ? grid.querySelectorAll('.products__card') : [];

    if (!tabs.length || !cards.length || !grid) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var handle = tab.dataset.tab;

        tabs.forEach(function (t) { t.classList.remove('products__tab--active'); });
        tab.classList.add('products__tab--active');

        grid.classList.add('products__grid--fading');

        setTimeout(function () {
          cards.forEach(function (card) {
            if (handle === 'all') {
              card.classList.remove('products__card--hidden');
            } else {
              var cols = (card.dataset.collections || '').split(' ');
              if (cols.indexOf(handle) !== -1) {
                card.classList.remove('products__card--hidden');
              } else {
                card.classList.add('products__card--hidden');
              }
            }
          });

          grid.classList.remove('products__grid--fading');
        }, 250);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var sliders = document.querySelectorAll('[data-hero-slider]');
    var section = document.querySelector('[data-slide-duration]');
    var duration = section ? parseFloat(section.dataset.slideDuration) * 1000 : 5000;
    var INITIAL_DELAY = duration;
    var INTERVAL = duration / 2;

    var sliderData = [];

    sliders.forEach(function (container) {
      var slides = container.querySelectorAll('.hero__slide');
      var images = container.querySelectorAll('.hero__image');

      // Hide skeleton once first image loads
      var firstImg = images[0];
      if (!firstImg) {
        container.classList.add('is-loaded');
      } else if (firstImg.complete) {
        container.classList.add('is-loaded');
      } else {
        firstImg.addEventListener('load', function () {
          container.classList.add('is-loaded');
        });
      }

      sliderData.push({ slides: slides, current: 0 });
    });

    if (sliderData.length < 2) return;
    if (sliderData[0].slides.length <= 1 && sliderData[1].slides.length <= 1) return;

    var left = sliderData[0];
    var right = sliderData[1];

    function advanceSide(side) {
      if (side.slides.length <= 1) return;
      var prev = side.current;
      side.current = (side.current + 1) % side.slides.length;
      side.slides[prev].style.opacity = '0';
      side.slides[side.current].style.opacity = '1';
    }

    // Alternate evenly: left, wait, right, wait, left, wait...
    var sides = [left, right];
    var turn = 0;

    function tick() {
      advanceSide(sides[turn]);
      turn = (turn + 1) % 2;
      setTimeout(tick, INTERVAL);
    }

    setTimeout(tick, INITIAL_DELAY);
  });

  } catch(e) { console.error(e); }
})();
})();
